import React, { Component } from "react";

export default class ErrorPage extends Component {
  render() {
    return (
      <React.Fragment>
        <div className="container container-small">
          <div className="row">
            <div className="col-12 text-center my-5">
              <h5 style={{ marginTop: 300 + "px" }}>Wystąpił błąd podczas pobierania danych, prosimy spróbować ponownie później...</h5>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}
